import * as Sentry from '@sentry/react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';

import App from './App';
import store from './services/store';

Sentry.init({
  dsn: 'https://6e0833134c3c4e508b98a648a3be2911@glitchtip.cheil.io/1',
  integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
  tracesSampleRate: 1.0,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
  environment: import.meta.env.MODE,
});

import './assets/fonts/SamsungSansBold.ttf';
import './assets/fonts/SamsungSharpSans-Bold.ttf';
import './assets/fonts/SamsungOneUILatin-400_v2.5.ttf';
import './index.css';

const container = document.getElementById('root');
const root = createRoot(container!);

root.render(
  <Provider store={store}>
    <App />
  </Provider>
);
